enum AppsTranslationVariant {
    letterFormation = 'letterFormation'
    , letterFormationDescription = 'letterFormationDescription'
    , woodPieces = 'woodPieces'
    , woodPiecesDescription = 'woodPiecesDescription'
    , woodPiecesNote = 'woodPiecesNote'
    , wdt = 'wdt'
    , wdtDescription = 'wdtDescription'
    , worksheetMaker = 'worksheetMaker'
    , worksheetMakerDescription = 'worksheetMakerDescription'
    , plusLive = 'plusLive'

}

export default AppsTranslationVariant;